import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    repayConfirmed: {
        id: '_.processing_payment.modal.early_repayment.confirmed',
        defaultMessage:
            '{amount} has been repaid by your debit card ending {paymentMethod}'
    },
    repayConfirmedSubtitle: {
        id: '_.processing_payment.modal.early_repayment.subtitle',
        defaultMessage: 'Your outstanding balance may take a moment to update'
    },
    drawDownConfirmed: {
        id: '_.processing_payment.modal.draw_down.confirmed',
        defaultMessage: `We've sent {amount} to your bank account`
    },
    returnToDashboard: {
        id: '_.navigation.return_to_dashboard',
        defaultMessage: 'Return to dashboard'
    }
});
